import React from "react";
import MapaExecucaoPage from "./MapaExecucaoPage";

function MapaExecucaoPageConnected() {
  return <MapaExecucaoPage />;
}

export default MapaExecucaoPageConnected;
